"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CostManagementWidget = void 0;
var Messages = require("../codegen/Messages");
var React = require("react");
var ActionsCard_1 = require("./ActionsCard");
var BillingConsumptionCard_1 = require("./BillingConsumptionCard");
var BillingDetailCard_1 = require("./BillingDetailCard");
var font_icons_mdl2_1 = require("@fluentui/font-icons-mdl2");
var types_1 = require("../context/types");
var CostManagementWidget = function (_a) {
    var locale = _a.locale, countryCode = _a.countryCode, region = _a.region, tenant = _a.tenant, domain = _a.domain, tenancySubscription = _a.tenancySubscription;
    font_icons_mdl2_1.initializeIcons();
    Messages.init(locale);
    var isChildTenancy = (tenancySubscription === null || tenancySubscription === void 0 ? void 0 : tenancySubscription.organizationType) ===
        types_1.TenancySubscriptionOrganizationTypeEnum.CHILD;
    return (React.createElement("div", { className: "costManagementWidget", "data-test-id": "costManagementWidget" },
        React.createElement("div", { className: "cards" },
            tenancySubscription && !isChildTenancy && (React.createElement(BillingConsumptionCard_1.default, { locale: locale, tenancySubscription: tenancySubscription })),
            tenancySubscription && !isChildTenancy && (React.createElement(BillingDetailCard_1.default, { locale: locale, tenancySubscription: tenancySubscription })),
            React.createElement(ActionsCard_1.default, { countryCode: countryCode, region: region, tenant: tenant, domain: domain, tenancySubscription: tenancySubscription }))));
};
exports.CostManagementWidget = CostManagementWidget;
//# sourceMappingURL=CostManagementWidget.js.map